<!--
 * @Author: v_aydwang
 * @Date: 2022-12-30 15:36:56
 * @LastEditors: v_aydwang
 * @LastEditTime: 2022-12-30 15:36:56
 * @Description: 大屏-卡片预警文字播放动效
-->
<template>
  <div class="scroll">
    <div class="scroll-box">
      <div class="scroll" ref="scroll">
          {{text}}
      </div>
      <p class="getWidth" ref="getWidth">
           {{text}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      timer: null,
    };
  },
  created() {
    const timer = setTimeout(() => {
      this.move();
      clearTimeout(timer);
    }, 1000);
  },
  mounted() {},
  methods: {
    move() {
      const width = this.$refs.getWidth.scrollWidth;
      const { scroll } = this.$refs;
      let distance = 0;
      this.timer = setInterval(() => {
        distance -= 1;
        if (-distance >= width) {
          distance = 200;
        }
        scroll.style.transform = `translateX(${distance}px)`;
      }, 20);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/convert-viewport";
@import "@/styles/cardAssembly";
.scroll-box {
          overflow: hidden;
          width: vw(200);
          overflow: hidden;
        }
        .scroll {
          display: flex;
          word-break: keep-all;
          white-space: nowrap;
          cursor: default;
        }
        .getWidth {
          word-break: keep-all;
          white-space: nowrap;
          position: absolute;
          opacity: 0;
          top: 0;
        }
</style>
